import { Route, Routes } from "react-router-dom";
import Resultsets from "./pages/Resultsets";
import IndividualResultset from "./pages/IndividualResultset";
import IndividualResultsetVisualization from "./pages/IndividualResultsetVisualization";
import IndividualResultsetPrediction from "./pages/IndividualResultsetPrediction";
import IndividualCompoundPredictionV2 from "./pages/IndividualCompoundPredictionV2";

export default function ResultsetRoutes() {
    return (
        <Routes>
            <Route index element={<Resultsets/>} />
            <Route path=':id' element={<IndividualResultset/>} />
            <Route path=':resultset_id/prediction/:model_family_id/:smiles' element={<IndividualResultsetPrediction />} />
            <Route path='compound/:id' element={<IndividualCompoundPredictionV2 />} />
            <Route path='compound/:resultset_id/prediction/:model_family_id/:smiles' element={<IndividualResultsetPrediction />} />
            <Route path=':resultset_id/visualization/:id' element={<IndividualResultsetVisualization />}/>
        </Routes>
    )
}